// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 7664 ? "reactPlayerPreview" : chunkId) + "." + {"5655":"859ff001a1c50894","7664":"69b5e1458f2a80e4"}[chunkId] + ".js";
};